import { FC, useRef } from 'react';

import { IconButton, Modal, ModalContent, ModalOverlay, rem, SearchAltOutline, Tooltip, useBreakpointValue, useDisclosure } from '@bonusly/design-system';

import { useKeyboardTrigger } from '../../hooks/use-keyboard-trigger';
import { SearchContent } from './SearchContent';
import { TooltipContent } from './TooltipContent';

export const SearchModal: FC = () => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const isAtLeastXs = useBreakpointValue({ base: false, xs: true });
	const buttonRef = useRef(null);

	useKeyboardTrigger('k', onOpen, { meta: true });

	return (
		<>
			<Tooltip label={<TooltipContent />} isDisabled={!isAtLeastXs}>
				<IconButton
					_active={{ bg: 'secondary.bgAlphaHover', color: 'secondary.fgActive' }}
					_hover={{ bg: 'secondary.bgAlpha', color: 'secondary.fgActive' }}
					aria-label="Search"
					bg="bg.soft"
					borderRadius="full"
					color="text.default"
					fontSize="lg"
					boxSize={{ base: rem(40), xs: rem(44) }}
					icon={<SearchAltOutline size="md" />}
					id="primary-nav-search"
					onClick={onOpen}
				/>
			</Tooltip>

			<Modal finalFocusRef={buttonRef} isOpen={isOpen} onClose={onClose} scrollBehavior="inside" size="2xl">
				<ModalOverlay />
				<ModalContent
					bg="bg.surface"
					maxH={`min(calc(100% - 7.5rem), ${rem(664)})`}
					{...(!isAtLeastXs && {
						height: 'auto',
						maxHeight: '100%',
						borderRadius: 0,
						maxH: 'auto',
						my: 0,
					})}
				>
					<SearchContent onClose={onClose} />
				</ModalContent>
			</Modal>
		</>
	);
};
